import { render, staticRenderFns } from "./modalEditarPregao.vue?vue&type=template&id=15f92858"
import script from "./modalEditarPregao.vue?vue&type=script&lang=js"
export * from "./modalEditarPregao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports